import { render, staticRenderFns } from "./InstagramAlert.vue?vue&type=template&id=49e8409f&scoped=true&"
import script from "./InstagramAlert.vue?vue&type=script&lang=js&"
export * from "./InstagramAlert.vue?vue&type=script&lang=js&"
import style0 from "./InstagramAlert.vue?vue&type=style&index=0&id=49e8409f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e8409f",
  null
  
)

export default component.exports